import { EditorAction2 } from '../../../../../editor/browser/editorExtensions.js';
import { localize2WithPath } from '../../../../../nls.js';
import { Action2 } from '../../../../../platform/actions/common/actions.js';
const _moduleId = "vs/workbench/contrib/snippets/browser/commands/abstractSnippetsActions";
const defaultOptions = {
    category: ( localize2WithPath(_moduleId, 0, "Snippets")),
};
class SnippetsAction extends Action2 {
    constructor(desc) {
        super({ ...defaultOptions, ...desc });
    }
}
class SnippetEditorAction extends EditorAction2 {
    constructor(desc) {
        super({ ...defaultOptions, ...desc });
    }
}
export { SnippetEditorAction, SnippetsAction };
